var React = require('react');

function LiveEvent (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"2.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","key":0}),React.createElement("line",{"x1":"3.5","y1":"13.5","x2":"12.5","y2":"13.5","stroke":"currentColor","strokeLinecap":"round","key":1})]);
}

LiveEvent.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LiveEvent;

LiveEvent.default = LiveEvent;
